// @ts-nocheck
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    token: null,
    user: null,
    name: null,
    isUserLoggedIn: false,
    academyImage: "",
    language: "",
    selectedAcademy: "",
    managedAcademy: "",
    stripeAccountId: "",
    inApp: false,
    releasesCount: 0,
    notificationsCount: 0,
    permissions: [],
    theme: "light",
    hasAgreements: false,
    userImage: "",
    adminPlusVersion: false,
    migrationDialogViewed: false,
    welcomeMessageDismissed: false,
    setupCompleteDialogVisible: false,
    setupCompleteDialogShownByAcademyUser: {},
    onboardingStepState: null,
    isOnboardingUser: false,
    academyAdminStatus: null,
    userEmail: "",
    isUserAdminPlus: false,
  },
  plugins: [createPersistedState()],
  mutations: {
    setToken(state, token) {
      state.token = token;
      if (token) {
        state.isUserLoggedIn = true;
      } else {
        state.isUserLoggedIn = false;
      }
    },
    setUser(state, user) {
      state.user = user;
    },
    setName(state, name) {
      state.name = name;
    },
    setAcademyImage(state, img) {
      state.academyImage = img;
    },
    setLanguage(state, value) {
      state.language = value;
    },
    setSelectedAcademy(state, value) {
      state.selectedAcademy = value;
    },
    setManagedAcademy(state, value) {
      state.managedAcademy = value;
    },
    setStripeAccountId(state, value) {
      state.stripeAccountId = value;
    },
    setInApp(state, value) {
      state.inApp = value;
    },
    setReleasesCount(state, value) {
      state.releasesCount = value;
    },
    setPermissions(state, value) {
      state.permissions = value;
    },
    setTheme(state, value) {
      state.theme = value;
    },
    setNotificationsCount(state, value) {
      state.notificationsCount = value;
    },
    setHasAgreements(state, value) {
      state.hasAgreements = value;
    },
    setUserImage(state, img) {
      state.userImage = img;
    },
    setAdminPlusVersion(state, value) {
      state.adminPlusVersion = value;
    },
    setMigrationDialogViewed(state, value) {
      state.migrationDialogViewed = value;
    },
    setWelcomeMessageDismissed(state, value) {
      state.welcomeMessageDismissed = value;
    },
    setSetupCompleteDialogVisible(state, value) {
      state.setupCompleteDialogVisible = value;
    },
    markSetupCompleteDialogShown(state, { managedAcademy, userId }) {
      if (!managedAcademy || !userId) return;
      const key = `${managedAcademy}:${userId}`;
      state.setupCompleteDialogShownByAcademyUser = {
        ...(state.setupCompleteDialogShownByAcademyUser || {}),
        [key]: true,
      };
    },
    setIsOnboardingUser(state, value) {
      state.isOnboardingUser = value;
    },
    setAcademyAdminStatus(state, value) {
      state.academyAdminStatus = value;
    },
    setUserEmail(state, value) {
      state.userEmail = value;
    },
    setIsUserAdminPlus(state, value) {
      state.isUserAdminPlus = value;
    },
    setOnboardingStepState(state, value) {
      state.onboardingStepState = value;
    },
  },
  actions: {
    setToken({ commit }, token) {
      commit("setToken", token);
    },
    setUser({ commit }, user) {
      commit("setUser", user);
    },
    setName({ commit }, name) {
      commit("setName", name);
    },
    setAcademyImage({ commit }, image) {
      commit("setAcademyImage", image);
    },
    setLanguage({ commit }, value) {
      commit("setLanguage", value);
    },
    setSelectedAcademy({ commit }, value) {
      commit("setSelectedAcademy", value);
    },
    setManagedAcademy({ commit }, value) {
      commit("setManagedAcademy", value);
    },
    setStripeAccountId({ commit }, value) {
      commit("setStripeAccountId", value);
    },
    setInApp({ commit }, value) {
      commit("setInApp", value);
    },
    setReleasesCount({ commit }, value) {
      commit("setReleasesCount", value);
    },
    setPermissions({ commit }, value) {
      commit("setPermissions", value);
    },
    setTheme({ commit }, value) {
      commit("setTheme", value);
    },
    setNotificationsCount({ commit }, value) {
      commit("setNotificationsCount", value);
    },
    setHasAgreements({ commit }, value) {
      commit("setHasAgreements", value);
    },
    setUserImage({ commit }, image) {
      commit("setUserImage", image);
    },
    setAdminPlusVersion({ commit }, value) {
      commit("setAdminPlusVersion", value);
    },
    setMigrationDialogViewed({ commit }, value) {
      commit("setMigrationDialogViewed", value);
    },
    setWelcomeMessageDismissed({ commit }, value) {
      commit("setWelcomeMessageDismissed", value);
    },
    setSetupCompleteDialogVisible({ commit }, value) {
      commit("setSetupCompleteDialogVisible", value);
    },
    markSetupCompleteDialogShown({ commit }, payload) {
      commit("markSetupCompleteDialogShown", payload);
    },
    setIsOnboardingUser({ commit }, value) {
      commit("setIsOnboardingUser", value);
    },
    setAcademyAdminStatus({ commit }, value) {
      commit("setAcademyAdminStatus", value);
    },
    setUserEmail({ commit }, value) {
      commit("setUserEmail", value);
    },
    setIsUserAdminPlus({ commit }, value) {
      commit("setIsUserAdminPlus", value);
    },
    setOnboardingStepState({ commit }, value) {
      commit("setOnboardingStepState", value);
    },
  },
});
